










import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { Service, TableField, Plan, Cluster } from '@/types';
import { UtilService } from '@/services';

@Component({
  name: 'service-clusters',
  components: {}
})
export default class ServiceClusters extends Vue {
  @Prop({ required: true, type: Array })
  clusters!: Cluster[];

  items: Cluster[] = this.clusters;
  fields: TableField[] = [
    { key: 'name', label: 'Name' },
    { key: 'provider', label: 'Provider' },
    {
      key: 'zone',
      label: 'Zone'
    },
    { key: 'action', label: 'Action' }
  ];
}
